export enum Expansion {
  ClassicEra = 0,
  TheBurningCrusade = 1,
  WrathOfTheLichKing = 2,
  Cataclysm = 3,
  MistsOfPandaria = 4,
  WarlordsOfDraenor = 5,
  Legion = 6,
  BattleForAzeroth = 7,
  Shadowlands = 8,
  Dragonflight = 9,
  TheWarWithin = 10,
  Midnight = 11
}

export enum ExpansionPatch {
  Patch_300 = 300,
  Patch_310 = 310, // Ulduar
  Patch_320 = 320, // Trial of the Crusader
  Patch_340 = 340,
  Patch_400 = 400, // Cataclysm
  Patch_420 = 420, // Cataclysm - Firelands
  Patch_430 = 430, // Cataclysm - Dragon Soul
  Patch_500 = 500, // Mists of Pandaria
  Patch_520 = 520, // Mists of Pandaria - Throne of Thunder
  Patch_540 = 540, // Mists of Pandaria - Siege of Orgrimmar
  Patch_700 = 700, // We just lump everything in Legion into this, because we weren't tracking patches then
  Patch_800 = 800,
  Patch_810 = 810,
  Patch_815 = 815,
  Patch_820 = 820,
  Patch_830 = 830,
  Patch_901 = 901, // shadowlands pre-patch
  Patch_902 = 902, // shadowlands launch
  Patch_910 = 910, // shadowlands first major content patch
  Patch_920 = 920, // shadowlands second (and final) major content patch
  Patch_925 = 925, // shadowlands final patch (fated raids & new M+ season)
  Patch_1000 = 1000, // Dragonflight pre patch
  Patch_1002 = 1002, // Dragonflight launch
  Patch_1010 = 1010, // Dragonflight first major content patch
  Patch_1015 = 1015, // Dragonflight minor content patch (augmentation spec)
  Patch_1017 = 1017, // Dragonflight minor content patch (Fury Incarnate)
  Patch_1020 = 1020, // Dragonflight second major content patch
  Patch_1026 = 1026, // Dragonflight awakened season

  Patch_1100 = 1100, // The War Within (unsure if it's pre patch or not for now?)
  Patch_1105 = 1105, // TWW - 20th anniversary (BRD)
  Patch_1110 = 1110, // TWW - Season 2
  Patch_1120 = 1120, // TWW - Season 3

  Patch_1200 = 1200, // Midnight
  Patch_1202 = 1202, // Midnight Launch
  Patch_1207 = 1207, // Sporefall

  Unknown = 0
}

export enum ExpansionLevelCap {
  Classic = 60,
  BurningCrusade = 70,
  WrathOfTheLichKing = 80,
  Cataclysm = 85,
  MistsOfPandaria = 90,
  Shadowlands = 60, // level squish
  Dragonflight = 70, // level squish
  TheWarWithin = 80, // level squish
  Midnight = 90, // level squish
  BattleForAzeroth = 50,
  BattleForAzerothPreSquish = 120,
  BattleForAzerothPostSquish = 50,
  Legion = 110
}

export type TExpansionInfo = {
  slug: string;
  expansionId: Expansion;
  name: string;
  short_name: string;
  icon?: string;
  logoPath?: string;
};
